import { IElementTypesBySquadPosition } from "core-integration/src/store/element-types/types";

export const getElementTypeNameByCount = (
  positions: number[],
  elementTypesByPosition: IElementTypesBySquadPosition,
) => {
  const elementType = elementTypesByPosition[positions[0]].thisType;
  return positions.length > 1
    ? elementType.plural_name
    : elementType.singular_name;
};
